import { UnitOrganisasiDocument } from '~/apollo/gql/graphql'
import type { Option } from '~/types/form'

export const useUnitOrganisasiOptions = () => {
  const { result, loading, load } = useLazyQuery(UnitOrganisasiDocument)

  const options: ComputedRef<Option<string>[]> = computed(() => {
    if (!result.value) return []

    return result.value.unitOrganisasi.map(unor => ({
      label: unor.name,
      value: unor.kode
    }))
  })

  return { load, loading, options }
}
